import EventEmitter from 'wolfy87-eventemitter/EventEmitter'
window.EventEmitter = EventEmitter
